/**
 * Based on the incoming company attribute, this component will
 * render the appropriate component.  In some cases the company component
 * may include a logo, in some cases it will only be text.
 */

import React, { Fragment } from 'react';
import Argent from './argent';

function PoweredBy({ company }: any) {
  return <Fragment>{company === 'argent' && <Argent />}</Fragment>;
}

export default PoweredBy;
